module.exports = __webpack_public_path__ + "img/reject-coin.f8d08fa0.png";